import React, { useMemo, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';

import { CustomToaster } from './BaseUI';
import { EmployeeCard, MessageModal } from './shared';

function Expansions({ team, setMessageUser, canSendMessage }) {
  let url = null;
  return team.map((member, idx) => {
    if (member.team !== 'editorial') {
      url = null;
    } else {
      url = member.recentArticle;
    }
    return (
      <EmployeeCard
        key={idx}
        name={member.name}
        title={member.title}
        bio={member.bio}
        facebookUrl={member.facebookUrl}
        linkedinUrl={member.linkedinUrl}
        twitter={member.twitter}
        recentArticle={url}
        canSendMessage={canSendMessage}
        onMessage={() => setMessageUser({ id: member.userId, name: member.name })}
      />
    );
  });
}

export default function Team({ members, canSendMessage }) {
  const [messageUser, setMessageUser] = useState(null);
  const { width } = useWindowSize();

  const twoColumns = useMemo(() => {
    let columns = [[], []];
    members.forEach((member, idx) => {
      columns[idx % 2].push(member);
    });
    return columns;
  }, [members]);

  return (
    <>
      <div className="row">
        {width > 992 ? (
          <div>
            <div className="col-md-6">
              <Expansions
                team={twoColumns[0]}
                setMessageUser={setMessageUser}
                canSendMessage={canSendMessage}
              />
            </div>
            <div className="col-md-6">
              <Expansions
                team={twoColumns[1]}
                setMessageUser={setMessageUser}
                canSendMessage={canSendMessage}
              />
            </div>
          </div>
        ) : (
          <div className="col-md-12">
            <Expansions
              team={members}
              setMessageUser={setMessageUser}
              canSendMessage={canSendMessage}
            />
          </div>
        )}
      </div>
      {canSendMessage && <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />}
      <CustomToaster />
    </>
  );
}
